import { Link } from 'react-router-dom';
import './Footer.css';

const COLUMNS = [
  {
    title: 'ABOUT US',
    links: [{ label: 'The Story of Nayavarnam', to: '/about' }],
  },
  {
    title: 'SHOPPING WITH US',
    links: [{ label: 'Terms & Conditions', to: '/terms' }],
  },
  {
    title: 'HERE TO HELP',
    links: [
      { label: 'FAQs', to: '/faqs' },
      { label: 'Privacy Policy & Cookies', to: '/privacy' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="nv-footer" id="footer">
      <div className="container nv-footer__grid">
        {COLUMNS.map((col) => (
          <div key={col.title} className="nv-footer__col">
            <h4>{col.title}</h4>
            <ul>
              {col.links.map((link) => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="nv-footer__bottom">
        <p>© {new Date().getFullYear()} NAYAVARNAM. All rights reserved.</p>
      </div>
    </footer>
  );
}
